<template>
  <div class="main">
    <div ref="queryContent" v-sticky="{zIndex: 2001, stickyTop: 0, disabled: false}">
      <div class="header-wrapper">
        <el-form :disabled="isListLoading" :model="queryForm" ref="queryForm" :inline="true" label-width="0" :show-message="false">
          <div class="d-flex justify-content-between">
            <div class="filter-wrapper mr-2">
              <div class="filter-container">
                <div class="filter-item mr-3">
                  <label>文章：</label>
                  <el-form-item prop="groupId" class="inline-form-item">
                    <el-input v-model="queryForm.title" placeholder="文章ID或标题" clearable/>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>广告主：</label>
                  <el-form-item prop="groupId" class="inline-form-item">
                    <el-select v-model="queryForm.groupId" clearable class="filter-input">
                      <el-option
                        v-for="item in adUserList"
                        :key="item.CustomerId"
                        :label="item.RealName"
                        :value="item.CustomerId">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>渠道名称：</label>
                  <el-form-item prop="channel" class="inline-form-item">
                    <el-select v-model="queryForm.channel" clearable class="filter-input">
                      <el-option
                        v-for="item in channelList"
                        :key="item.Id"
                        :label="item.Name"
                        :value="item.Id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>时间：</label>
                  <el-form-item prop="dateRange" class="inline-form-item">
                    <el-date-picker
                      v-model="queryForm.dateRange"
                      type="daterange"
                      format="yyyy/MM/dd"
                      value-format="yyyy-MM-dd"
                      :editable="false"
                      clearable
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      range-separator="-">
                    </el-date-picker>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>维度：</label>
                  <el-form-item prop="dateRange" class="inline-form-item">
                    <el-checkbox v-model="queryForm.dimenDate">日期</el-checkbox>
                    <el-checkbox v-model="queryForm.dimenArticle">文章</el-checkbox>
                  </el-form-item>
                </div>
                <div class="filter-item">
                  <el-button :loading="isListLoading" :disabled="isExcelExporting" @click="fetchData" type="primary" class="query-button" icon="el-icon-search">查询</el-button>
                  <el-button :disabled="isListLoading || isExcelExporting" @click="resetQueryForm" class="query-button">重置</el-button>
                </div>
              </div>
            </div>
            <div class="tools flex-shrink-0">
              <div class="filter-item">
                <el-button :loading="isExcelExporting" :disabled="isListLoading" @click="exportExcel" type="warning" class="query-button">导出Excel</el-button>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="main-content">
        <el-table
          ref="table"
          :data="rawListData"
          v-loading="isListLoading"
          border
          fit
          highlight-current-row
          style="width: 100%;"
          :max-height="tableMaxHeight">
          <el-table-column
            prop="Day"
            v-if="isGroupData"
            label="日期">
          </el-table-column>
          <el-table-column
            min-width="150"
            prop="GroupName"
            v-if="isGroupArticle"
            label="广告主">
          </el-table-column>
          <el-table-column
            min-width="150"
            prop="ChannelName"
            v-if="isGroupArticle && isGroupData"
            label="渠道">
          </el-table-column>
          <el-table-column
            prop="ArticleId"
            v-if="isGroupArticle"
            label="文章ID">
          </el-table-column>
          <el-table-column
            min-width="200"
            prop="ArticleName"
            v-if="isGroupArticle"
            label="文章标题">
          </el-table-column>
          <el-table-column
            min-width="120"
            prop="RealDayCountSum"
            label="阅读量">
          </el-table-column>
          <el-table-column
              min-width="120"
              prop="PriceCount"
              label="收益">
            <template slot-scope="scope">
              {{scope.row.PriceCount / 100}}
            </template>
          </el-table-column>
        </el-table>
        <div class="text-center py-3">
          <el-pagination
            :disabled="isListLoading"
            @current-change="handleCurrentChange"
            @size-change="handlePageSizeChange"
            :current-page.sync="tableCurrentPage"
            :page-sizes="tablePageSizeOption"
            :page-size="tablePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableTotalSize"
            background>
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky'
import AccountApi from '@/api/Account'
import * as JumpAmountApi from '@/api/jumpAmount'
import swal from 'sweetalert2'
import { deepClone } from '@/utils'
import exportExcel from '@/utils/exportExcel'
import moment from 'moment'

export default {
  name: 'jump-amount-daily-stats',
  directives: {
    sticky: VueSticky
  },
  data() {
    const groupId = null
    const channel = null
    const dateRange = []
    const dimenDate = null
    const dimenArticle = null
    const title = null
    const today = moment().format('YYYY-MM-DD')
    const oneWeek = moment().subtract('days', 6).format('YYYY-MM-DD')

    return {
      queryForm: {
        // 广告主
        groupId,
        // 渠道
        channel,
        // 时间
        dateRange: [oneWeek, today],
        dimenDate,
        dimenArticle,
        title
      },
      isGroupData: false,
      isGroupArticle: false,
      adUserList: [],
      channelList: [],

      isListLoading: false,
      isExcelExporting: false,

      // 保存之前的请求参数
      query: deepClone({ groupId, channel, dateRange, dimenDate, dimenArticle, title }),

      rawListData: [],

      // 表格当前页
      tableCurrentPage: 1,
      // 表格一页条数可选项
      tablePageSizeOption: [10, 20, 30],
      // 表格一页条数
      tablePageSize: 20,
      // 总条数
      tableTotalSize: 0,

      // 除表格外内容区域高度
      othersHeight: 0
    }
  },
  computed: {
    adUserMap() {
      return new Map(this.adUserList.map(item => [item.CustomerId, item.RealName]))
    },
    channelMap() {
      return new Map(this.channelList.map(item => [item.Id, item.Name]))
    },
    tableMaxHeight() {
      return Math.max(this.$store.getters.containerHeight - this.othersHeight, 300)
    }
  },
  created() {
    const { path, query } = this.$route
    const { channel, ...otherQuery } = query
    if (channel) {
      this.queryForm = {
        groupId: null,
        channel,
        dateRange: []
      }
      delete query.channel
      this.$nextTick(() => {
        this.$router.replace({
          path: path,
          query: otherQuery
        })
      })
    }
    this.getAdUsers()
    this.getChannelList()
    this.fetchData()
  },
  mounted() {
  },
  activated() {
    const { path, query } = this.$route
    const { channel, ...otherQuery } = query
    if (channel) {
      this.queryForm = {
        groupId: null,
        channel,
        dateRange: []
      }
      this.getAdUsers()
      this.getChannelList()
      this.fetchData()
      this.$router.replace({
        path: path,
        query: otherQuery
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      const queryContent = this.$refs.queryContent
      const queryContentHeight = queryContent ? Math.round(queryContent.clientHeight) : 0
      this.othersHeight = queryContentHeight + 41 + 64
    })
  },
  methods: {
    // 重置查询
    resetQueryForm() {
      this.$refs.queryForm.resetFields()
    },
    getAdUsers() {
      AccountApi.getAdUsers().then(({ data }) => {
        if (data.Status === 200) {
          this.adUserList = data.Result instanceof Array ? data.Result : []
        }
      })
    },
    getChannelList() {
      const postData = {
        page: 1,
        limit: 9999
      }
      JumpAmountApi.getArticleChannelPageList(postData).then(({ data }) => {
        if (data.Status === 200) {
          this.channelList = data.Result.list
        }
      })
    },
    fetchData() {
      // 克隆当前查询条件
      this.query = deepClone(this.queryForm)
      this.tableCurrentPage = 1
      this.tableTotalSize = 0
      if (this.queryForm.dimenDate) {
        this.isGroupData = true
      } else {
        this.isGroupData = false
      }
      if (this.queryForm.dimenArticle) {
        this.isGroupArticle = true
      } else {
        this.isGroupArticle = false
      }
      this.fetchList()
    },
    fetchList() {
      this.isListLoading = true
      this.rawListData = []

      const { groupId, channel, dateRange, title } = this.query

      const postData = {
        page: this.tableCurrentPage,
        limit: this.tablePageSize
      }
      groupId && (postData.groupId = groupId)
      channel && (postData.channelId = channel)
      title && (postData.title = title)
      if (dateRange.length === 2) {
        postData.startDate = dateRange[0]
        postData.endDate = dateRange[1]
      }
      var group = ''
      if (this.queryForm.dimenDate) {
        group = 'Day,'
      }
      if (this.queryForm.dimenArticle) {
        group += 'ArticleId'
      }
      postData.group = group
      console.log(this.queryForm.dimenDate)

      JumpAmountApi.getDailyStatsList(postData).then(({ data }) => {
        this.isListLoading = false
        if (data.Status !== 200) {
          swal({
            text: data.Result.ErrorMsg,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }
        this.rawListData = data.Result.list
        this.tableTotalSize = parseInt(data.Result.count) || 0
      }).catch(error => {
        swal({
          text: error.message,
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
        this.isListLoading = false
      })
    },
    handleCurrentChange(value) {
      this.fetchList()
    },
    handlePageSizeChange(value) {
      this.tableCurrentPage = 1
      this.tablePageSize = value
      this.fetchList()
    },
    exportExcel() {
      this.isExcelExporting = true
      const fileName = '跳转量每日数据统计'

      const { groupId, channel, dateRange } = this.queryForm

      const postData = {
        page: 1,
        limit: 9999
      }
      groupId && (postData.groupId = groupId)
      channel && (postData.channelId = channel)
      if (dateRange.length === 2) {
        postData.startDate = dateRange[0]
        postData.endDate = dateRange[1]
      }
      var group = ''
      if (this.queryForm.dimenDate) {
        group = 'Day,'
      }
      if (this.queryForm.dimenArticle) {
        group += 'ArticleId'
      }
      postData.group = group
      JumpAmountApi.getDailyStatsList(postData).then(({ data }) => {
        if (data.Status !== 200) {
          swal({
            text: data.Result.ErrorMsg,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          this.isExcelExporting = false
          return
        }
        const rawListData = data.Result.list
        rawListData.forEach(item => {
          item.PriceCount = item.PriceCount ? (item.PriceCount / 100) : 0
        })
        var fields = {}
        if (this.isGroupData) {
          fields.Day = '日期'
        }
        if (this.isGroupArticle) {
          fields.GroupName = '广告主'
        }
        if (this.isGroupArticle && this.isGroupData) {
          fields.ChannelName = '渠道'
        }
        if (this.isGroupArticle) {
          fields.ArticleId = '文章ID'
          fields.ArticleName = '文章标题'
        }
        fields.RealDayCountSum = '阅读量'
        fields.PriceCount = '收益'
        // const fields = {
        //   Day: '日期',
        //   GroupName: '广告主',
        //   ChannelName: '渠道',
        //   ArticleId: '文章ID',
        //   ArticleName: '文章标题',
        //   RealDayCount: '阅读量',
        //   AllPrice: '收益'
        // }

        exportExcel([{ sheetName: fileName, data: rawListData }], fields, fileName)
        this.isExcelExporting = false
      }).catch(() => {
        this.isExcelExporting = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  display: table;
  table-layout: fixed;
  min-width: 1300px;
  width: 100%;
  height: 100%;
  background-color: #ececec;
  .filter-item {
    margin-bottom: 15px;
  }
  .filter-container {
    .filter-item {
      display: inline-block;
      white-space: nowrap;
    }
  }
  .filter-input {
    width: 200px;
  }
  .query-button {
    width: 100px;
  }
  .tool-button {
    width: 100px;
  }
  .oper-button {
    width: 80px;
  }
  .header-wrapper {
    padding: 14px 20px 0;
    box-shadow: 0 1px 3px rgba(0,0,0,.1);
    background-color: #fff;
  }
  .content-wrapper {
    padding: 20px;
    .main-content {
      border-top: 1px solid #e1e3e4;
      border-left: 1px solid #e1e3e4;
      border-right: 1px solid #e1e3e4;
      background-color: #fff;
      .button-wrapper {
        padding: 20px 20px;
      }
    }
  }
  .inline-form-item {
    display: inline-block;
    margin: 0;
    vertical-align: middle;
  }
}
</style>
